import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'RandomProgram',
})
export class RandomPipe implements PipeTransform {
  transform(items: any[], type: string): any[] {
    if (!items) {
      return []
    }
    if (type === 'rand') {
      let control: number = items.length
      let tempItem: object
      let index: number
      // Mientras hay elementos en el array
      while (control > 0) {
        // Elige un índice aleatorio
        index = Math.floor(Math.random() * control)
        // Disminuye control en 1
        control--
        // Cambia el último elemento con él
        tempItem = items[control]
        items[control] = items[index]
        items[index] = tempItem
      }
      return items
    } else {
      return items
    }
  }
}
